<template>
  <v-card v-if="model.id" class="elevation-2">
    <v-card-title class="text-h5 text-title font-weight-bold black--text">
      <h2 class="font-weight-bold text--primary">Datos Generales</h2>
    </v-card-title>
    <v-card-text>
        <v-row dense>
            <v-col cols="12">
              <v-card width="auto" outlined>
                  <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="4">
                            <label class="font-weight-bold subtitle-1 text--primary">Folio: </label>
                            <p class="font-weight-bold text--secondary">
                                {{model.folio}}
                            </p>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <label class="font-weight-bold subtitle-1 text--primary">Tipo Inventario: </label>
                            <p class="font-weight-bold text--secondary">
                                {{model.tipo_inventario.nombre}}
                            </p>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <label class="font-weight-bold subtitle-1 text--primary">Categoria: </label>
                            <p class="font-weight-bold text--secondary">
                                {{model.descripcion.familia.nombre}}
                            </p>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <label class="font-weight-bold subtitle-1 text--primary">Nombre del Equipo: </label>
                            <p class="font-weight-bold text--secondary">
                                {{model.NombreEquipo}}
                            </p>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <label class="font-weight-bold subtitle-1 text--primary">Marca - Modelo: </label>
                            <p class="font-weight-bold text--secondary">
                                {{model.MarcaModelo}}
                            </p>
                        </v-col>
                    </v-row>
                    <v-row dense v-if="model.tipo_inventario_id !== 5">
                        <v-col cols="12" sm="6">
                            <label class="font-weight-bold subtitle-1 text--primary">Personal Resguardante: </label>
                            <p class="font-weight-bold text--secondary">
                                {{model.PersonalResguardante}}
                            </p>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <label class="font-weight-bold subtitle-1 text--primary">Personal Asignado: </label>
                            <p class="font-weight-bold text--secondary">
                                {{model.PersonalAsignado}}
                            </p>
                        </v-col>
                    </v-row>
                  </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
                <v-card width="auto" outlined>
                    <v-card-title class="text-title font-weight-bold black--text">
                      Caracteristicas del
                      <span v-if="model.tipo_inventario_id !== 5"> Equipo </span>
                      <span v-else> Insumo </span>
                    </v-card-title>
                    <v-card-text>
                    <v-row dense v-if="familia">
                        <v-col v-for="(field, index) in familia.fields" :key="index" :cols="field.cols" sm="6">
                            <label class="font-weight-bold subtitle-1 text--primary">{{field.name}} </label>
                            <p class="font-weight-bold text--secondary">
                                {{model.caracteristicas[field.nameid]}}
                            </p>
                        </v-col>
                    </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  props: ['model', 'onSuccess'],
  data: () => ({
    itemInsumos: {},
    familia: null
  }),
  methods: {
    ...mapActions(['urlGetServiceActionTwo']),
    sendEvent (item) {
      this.onSuccess(item)
    },
    ...mapMutations([])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objectTwo'])
  },
  watch: {
    model (val) {
      if (val.id) {
        const router = this.get_urls['familias.caracteristica']
        this.urlGetServiceActionTwo({ url: router, params: `/${val.descripcion.familia.id}`, replace: '/{id}' })
      }
    },
    get_objectTwo (val) {
      if (val) {
        this.familia = val
      }
    }

  }
}
</script>

<style>

</style>
